import { getFunctions, httpsCallable } from "firebase/functions";
import { auth, app } from "../config/firebase";

export class StripeApi {

  public static buyBananas = async (items: number): Promise<{ url: string }> => {
    if (!auth.currentUser) throw new Error("Not signed in");
    
    const successUrl = `${window.location.origin}/banana-stand`;
    const cancelUrl = `${window.location.origin}/banana-stand`;

    try {
      const apiCall = httpsCallable<{ items: number, successUrl: string, cancelUrl: string  }, { url: string }>(
        getFunctions(app),
        "createCheckoutSession"
      );

      const res = await apiCall({ items, successUrl, cancelUrl });
      return res.data;
    } catch (error: any) {
      throw new Error(error.message || "Failed to create checkout session.");
    }
  }

  public static updateStripePrices = async (): Promise<{ 
    price5bananas: number,
    price20bananas: number,
    price50bananas: number, 
   }> => {
    if (!auth.currentUser) throw new Error("Not signed in");

    try {
      const apiCall = httpsCallable<{ }, { 
        price5bananas: number,
        price20bananas: number,
        price50bananas: number, 
      }>(
        getFunctions(app),
        "updateStripePrices"
      );

      const res = await apiCall({ });
      return res.data;
    } catch (error: any) {
      throw new Error(error.message || "Failed to update stripe prices.");
    }
  }
}